<script>
import { Pie, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default Pie.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    /* eslint-disable no-underscore-dangle */
    this.renderChart(this.chartData, this.options);
    this.$emit('chartCreated', this._chart);
  },
});
</script>



// WEBPACK FOOTER //
// BasePieChart.vue?7d64ab6b